module.exports = __webpack_public_path__ + "img/BAU Seniors_26.04162fb9.jpg";